import {Component, inject, Input} from '@angular/core';
import {CommonModule, NgClass} from "@angular/common";
import {
  MatCell, MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef, MatTable
} from "@angular/material/table";
import {IApplication} from "../../../../../../assets/types/dtoTypes";
import countries from "../../../../../../assets/country.json";
import {Router} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {
  ApplicationActionsComponent
} from "../../../../../shared/app-application-actions/app-application-actions.component";

@Component({
  selector: 'app-applications-table',
  imports: [
    NgClass,
    MatHeaderRowDef,
    MatRowDef,
    MatHeaderRow,
    MatRow,
    CommonModule,
    MatCell,
    MatHeaderCell,
    MatColumnDef,
    MatCellDef,
    MatHeaderCellDef,
    MatTable,
    TranslateModule,
    ApplicationActionsComponent,
  ],
  templateUrl: './applications-table.component.html',
  styleUrl: './applications-table.component.scss',
  standalone: true
})
export class ApplicationsTableComponent {

  @Input() applications: IApplication[] = [];

  private router = inject(Router);

  countryCodeMap: { [key: string]: string } = {};

  displayedColumns: string[] = ['name', 'country', 'language', 'date', 'status', 'action'];

  constructor() {
    countries.forEach((country) => {
      this.countryCodeMap[country.name.toLowerCase()] = country.alpha2Code.toLowerCase();
    });
  }

  navigateToApplication(app: IApplication): void {
    this.router.navigate(['/application-overview', app.id]);
  }

  getFlagEmoji(location?: string | null): string {
    if (!location) {
      return '🏳️';
    }

    const countryPart = location.split(',').pop()?.trim().toLowerCase() || '';
    const code = this.countryCodeMap[countryPart];

    if (!code) return '🏳️';

    return code
      .toUpperCase()
      .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt(0)));
  }
}
